/**
 * elgin-api migration 20260716120000_normalize_service_request_activity_names
 * renamed these `Activities.Item` values to match the mobile app, but the
 * `Activity` translation keys in some environments still use the old names.
 * Maps the current Item name to the Item name its translations may still use.
 */
const LEGACY_ITEM_NAMES: Record<string, string> = {
    SNOW_ICE_REMOVAL: 'SNOW_AND_ICE_REMOVAL',
    CODE_VIOLATIONS_REQUESTS: 'CODE_VIOLATIONS_AND_REQUESTS',
    GARBAGE_RECYCLING_GENERAL_SERVICES: 'GARBAGE__RECYCLING_GENERAL_SERVICES',
    GARBAGE__RECYCLING_TOTER_REPAIR__REPLACEMENT: 'GARBAGE_RECYCLING_TOTER_REPAIR_REPLACE',
};

/**
 * Translation keys for an activity's label (or `_DESCRIPTION`), current name
 * first. Pass the result straight to `t()`: i18next uses the first key it finds.
 */
export function activityTranslationKeys(action: string, item: string, suffix = ''): string[] {
    const keys = [`Activity.${action}_${item}${suffix}`];
    const legacyItem = LEGACY_ITEM_NAMES[item];
    if (legacyItem) {
        keys.push(`Activity.${action}_${legacyItem}${suffix}`);
    }
    return keys;
}
